module.exports = __webpack_public_path__ + "img/nImg_1.5c744c00.png";